import { createContext, useContext, useMemo, useState } from "react";

const LayoutDisclosureContext = createContext(null);

export function LayoutDisclosureProvider({ children }) {
  const [expandedSections, setExpandedSections] = useState({
    "quick presets": false,
    heading: false,
    structure: false,
    spacing: false,
  });

  const value = useMemo(
    () => ({
      expandedSections,
      setSectionExpanded: (section, expanded) => {
        setExpandedSections((current) => {
          const nextExpanded =
            typeof expanded === "function"
              ? expanded(Boolean(current[section]))
              : expanded;

          return {
            ...current,
            [section]: Boolean(nextExpanded),
          };
        });
      },
    }),
    [expandedSections],
  );

  return (
    <LayoutDisclosureContext.Provider value={value}>
      {children}
    </LayoutDisclosureContext.Provider>
  );
}

export function usePersistentLayoutDisclosure(section) {
  const context = useContext(LayoutDisclosureContext);
  const [localExpanded, setLocalExpanded] = useState(false);

  if (!context) {
    return [localExpanded, setLocalExpanded];
  }

  return [
    Boolean(context.expandedSections[section]),
    (expanded) => context.setSectionExpanded(section, expanded),
  ];
}
